module.exports = __webpack_public_path__ + "img/schedule-right.7cfe631f.png";